import { render, staticRenderFns } from "./True.vue?vue&type=template&id=0770b325&scoped=true"
import script from "./True.vue?vue&type=script&lang=ts"
export * from "./True.vue?vue&type=script&lang=ts"
import style0 from "./True.vue?vue&type=style&index=0&id=0770b325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770b325",
  null
  
)

export default component.exports